var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7709 12.2934C28.0341 12.1208 26.2973 11.9914 24.5497 11.8943V11.8835L24.3124 10.4811C24.1506 9.48868 23.9133 8 21.389 8H18.5626C16.0491 8 15.8118 9.42396 15.6392 10.4703L15.4126 11.8512C14.4094 11.9159 13.4062 11.9806 12.4029 12.0777L10.2023 12.2934C9.74918 12.3366 9.42555 12.7357 9.4687 13.178C9.51185 13.6203 9.9002 13.9439 10.3533 13.9008L12.5539 13.685C18.2066 13.1241 23.9025 13.3398 29.6199 13.9116H29.7062C30.1161 13.9116 30.4721 13.5987 30.5152 13.178C30.5476 12.7357 30.224 12.3366 29.7709 12.2934Z",
    fill: "#D20A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9384 15.8459C26.7033 15.5741 26.38 15.4219 26.0469 15.4219H13.664C13.331 15.4219 12.9979 15.5741 12.7726 15.8459C12.5472 16.1177 12.4199 16.4874 12.4395 16.8679L13.0469 28.023C13.1546 29.6756 13.2918 31.7414 16.7108 31.7414H23.0001C26.4192 31.7414 26.5564 29.6865 26.6641 28.023L27.2715 16.8788C27.2911 16.4874 27.1637 16.1177 26.9384 15.8459ZM21.4817 26.2943H18.2194C17.8178 26.2943 17.4847 25.9247 17.4847 25.4789C17.4847 25.0331 17.8178 24.6634 18.2194 24.6634H21.4817C21.8833 24.6634 22.2164 25.0331 22.2164 25.4789C22.2164 25.9247 21.8833 26.2943 21.4817 26.2943ZM22.3046 21.9453H17.4063C17.0047 21.9453 16.6716 21.5757 16.6716 21.1299C16.6716 20.6841 17.0047 20.3145 17.4063 20.3145H22.3046C22.7063 20.3145 23.0393 20.6841 23.0393 21.1299C23.0393 21.5757 22.7063 21.9453 22.3046 21.9453Z",
    fill: "#D20A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.2fd9095dacdccf0d41a210cba6aa3017.svg";
export { ForwardRef as ReactComponent };